module.exports = __webpack_public_path__ + "static/received-8c38b769ed611635727a984f34dfcea2.png";